export default {"src":"/_next/static/media/replay_dark.d1467962.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};